import React from 'react';
import PhoneInput from 'react-phone-number-input';
import cx from 'classnames';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { fade, withStyles } from '@material-ui/core/styles';
import 'react-phone-number-input/style.css';

const styles = (theme) => ({
  root: {
    'display': 'flex',
    'flexDirection': 'column',
    '& input': {
      'width': 'auto',
      'position': 'relative',
      'backgroundColor': theme.palette.action.disabledBackground,
      'border': '1px solid transparent',
      'padding': '18px 22px',
      '&:focus': {
        backgroundColor: theme.palette.primary.light,
      },
    },
    '& .PhoneInput': {
      'display': 'inline-flex',
      'alignItems': 'center',
      'height': 'unset',
      'padding': 0,
      '& .PhoneInputCountry': {
        backgroundColor: theme.palette.action.disabledBackground,
        padding: '14px 8px',
        alignSelf: 'center',
        margin: 0,
        height: '100%',
        fontSize: 30,
      },
    },
  },

  margin: {
    marginBottom: theme.spacing(3),
  },
  label: {
    marginBottom: theme.spacing(1),
    display: 'block',
    position: 'initial',
    transform: 'scale(1)',
    color: theme.palette.text.primary,
  },
  hint: {
    display: 'block',
  },
});

const CustomPhoneInput = ({
  classes,
  label,
  hint,
  placeholder,
  fullWidth,
  hasError,
  helpText,
  onChange,
  value,
  size,
  className,
  disableMargin,
  ...props
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      className={cx(classes.root, !disableMargin && classes.margin)}
    >
      {label && (
        <InputLabel disableAnimation shrink className={classes.label}>
          {label}
        </InputLabel>
      )}
      {hint && (
        <Typography
          className={classes.hint}
          color="textSecondary"
          variant="caption"
        >
          {hint}
        </Typography>
      )}
      <PhoneInput
        countrySelectProps={{ unicodeFlags: true }}
        defaultCountry="US"
        value={value}
        onChange={onChange}
        className={`MuiInputBase-input ${classes.textfield}`}
        placeholder={placeholder}
        {...props}
      />
      {hasError && <FormHelperText error>{helpText}</FormHelperText>}
    </FormControl>
  );
};

export default withStyles(styles)(CustomPhoneInput);
